/* SkyStruct × Shopify Forms — progressive enhancement around the INLINE Shopify Forms app block.
   Loaded only by the Contact and Demo sections (Shopify theme only; not part of the Source build).

   What it does
   - Contact: places the visitor's pre-footer "project scope" draft (sessionStorage key
     ss_project_scope_draft, written by the pre-footer composer) into the form's multi-line
     Project scope field, then clears the draft — only after the value is confirmed in the field.
   - Contact: the "How can we help?" route buttons pick the matching option in an enquiry-type
     dropdown when the form has one (matched by option text).
   - Demo: ?product=lite|pro (from pricing / product CTAs; not sensitive) selects the matching
     product option when the form has one.
   What it never does
   - submit, validate or restyle the form; send or log the scope; put it in the URL or in
     persistent storage. Shopify Forms owns fields, validation, submission and customer data.

   Shopify Forms has no documented prefill API: the rendered form is located defensively (light
   DOM, open shadow roots, same-origin iframes). The field is matched by its LABEL (Theme Editor
   setting "Project-scope field label(s)", default "Project scope|نطاق المشروع"), then by a stable
   name/id hint, then — only if the form has exactly one multi-line field — that field.
   Bounded: a MutationObserver plus a light re-check for up to 20 s, then it stops. Any failure
   leaves the form untouched and fully usable (the field is simply empty). */
(function () {
  'use strict';
  var KEY = 'ss_project_scope_draft';
  var MAX_AGE = 30 * 60 * 1000; // drafts older than 30 minutes are discarded
  var TIMEOUT = 20000;

  function readDraft() {
    try {
      var raw = window.sessionStorage.getItem(KEY);
      if (!raw) return null;
      var d = JSON.parse(raw);
      if (!d || typeof d.v !== 'string' || !d.v || (d.t && Date.now() - d.t > MAX_AGE)) { window.sessionStorage.removeItem(KEY); return null; }
      return d.v;
    } catch (e) { return null; }
  }
  function clearDraft() { try { window.sessionStorage.removeItem(KEY); } catch (e) { /* ignore */ } }

  var norm = function (s) { return String(s || '').replace(/[*: ]/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase(); };

  // Every searchable root under the slot: the slot itself, open shadow roots, same-origin iframes.
  function roots(start) {
    var out = [start], queue = [start];
    while (queue.length) {
      var r = queue.shift(), all = r.querySelectorAll ? r.querySelectorAll('*') : [];
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        if (el.shadowRoot) { out.push(el.shadowRoot); queue.push(el.shadowRoot); }
        if (el.tagName === 'IFRAME') { try { var d = el.contentDocument; if (d && d.body) { out.push(d); queue.push(d); } } catch (e) { /* cross-origin: not reachable */ } }
      }
    }
    return out;
  }
  function labelText(field) {
    var parts = [];
    try { if (field.labels) for (var i = 0; i < field.labels.length; i++) parts.push(field.labels[i].textContent); } catch (e) { /* ignore */ }
    parts.push(field.getAttribute('aria-label'), field.getAttribute('placeholder'));
    var by = field.getAttribute('aria-labelledby');
    if (by) by.split(/\s+/).forEach(function (id) { var n = field.getRootNode().getElementById ? field.getRootNode().getElementById(id) : null; if (n) parts.push(n.textContent); });
    return norm(parts.join(' '));
  }
  function collect(slot, selector) {
    var list = [];
    roots(slot).forEach(function (r) { if (r.querySelectorAll) list = list.concat(Array.prototype.slice.call(r.querySelectorAll(selector))); });
    return list.filter(function (el) { return !el.disabled && el.type !== 'hidden'; });
  }
  function findScopeField(slot, labels) {
    var areas = collect(slot, 'textarea');
    var fields = areas.concat(collect(slot, 'input[type="text"], input:not([type])'));
    for (var i = 0; i < labels.length; i++) {
      var want = norm(labels[i]);
      if (!want) continue;
      for (var j = 0; j < fields.length; j++) { var t = labelText(fields[j]); if (t === want || t.indexOf(want) === 0) return fields[j]; }
    }
    for (var k = 0; k < areas.length; k++) { if (/scope|project|message|requirement/i.test((areas[k].name || '') + ' ' + (areas[k].id || ''))) return areas[k]; }
    return areas.length === 1 ? areas[0] : null;
  }
  // Set a value the way a user would, so the app's own state (frameworks) picks it up.
  function setNative(field, value) {
    var proto = field.tagName === 'TEXTAREA' ? window.HTMLTextAreaElement.prototype : window.HTMLInputElement.prototype;
    var desc = Object.getOwnPropertyDescriptor(proto, 'value');
    if (desc && desc.set) desc.set.call(field, value); else field.value = value;
    field.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    field.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
  }
  function selectOption(slot, words) {
    var re = new RegExp(words.join('|'), 'i'), done = false;
    collect(slot, 'select').forEach(function (sel) {
      if (done) return;
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].value && re.test(sel.options[i].textContent)) {
          var desc = Object.getOwnPropertyDescriptor(window.HTMLSelectElement.prototype, 'value');
          if (desc && desc.set) desc.set.call(sel, sel.options[i].value); else sel.value = sel.options[i].value;
          sel.dispatchEvent(new Event('change', { bubbles: true, composed: true })); done = true; return;
        }
      }
    });
    if (done) return true;
    collect(slot, 'input[type="radio"]').forEach(function (r) {
      if (done) return;
      var t = (r.labels && r.labels[0] ? r.labels[0].textContent : '') + ' ' + r.value;
      if (re.test(t)) { r.click(); done = true; }
    });
    return done;
  }
  // Watch the slot until fn() reports success or the time budget runs out.
  function whenRendered(slot, fn) {
    if (fn()) return;
    var stop = false, mo = null, timer = null, t0 = Date.now();
    var check = function () { if (stop) return; if (fn() || Date.now() - t0 > TIMEOUT) end(); };
    var end = function () { stop = true; if (mo) mo.disconnect(); clearInterval(timer); };
    if ('MutationObserver' in window) { mo = new MutationObserver(check); mo.observe(slot, { childList: true, subtree: true }); }
    timer = setInterval(check, 500); // shadow-DOM / iframe renders are not seen by the observer
  }

  function init() {
    var slot = document.querySelector('[data-ss-shopify-form]');
    if (!slot) return;
    var kind = slot.getAttribute('data-ss-shopify-form');
    var labels = (slot.getAttribute('data-ss-shopify-prefill-labels') || 'Project scope').split('|');

    if (kind === 'contact') {
      var draft = readDraft();
      if (draft) {
        whenRendered(slot, function () {
          try {
            var field = findScopeField(slot, labels);
            if (!field) return false;
            if (!field.value) setNative(field, draft);
            if (field.value === draft || field.value) { clearDraft(); return true; }
            return false;
          } catch (e) { return true; } // give up quietly; the form stays fully usable
        });
      }
      // Route buttons (Sales / Support / General) → matching enquiry-type option, if the form has one.
      var MAP = { Sales: ['sales', 'مبيعات'], Support: ['support', 'دعم'], 'General enquiry': ['general', 'عام'], Partnership: ['partner', 'شراك'] };
      document.querySelectorAll('[data-ss-route]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          document.querySelectorAll('[data-ss-route]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
          var words = MAP[btn.getAttribute('data-ss-route')];
          if (words) { try { selectOption(slot, words); } catch (e) { /* ignore */ } }
        });
      });
    }

    if (kind === 'demo') {
      var product = null;
      try { product = new URLSearchParams(window.location.search).get('product'); } catch (e) { product = null; }
      var words = product === 'lite' ? ['lite', 'لايت'] : product === 'pro' ? ['pro\\b', 'برو'] : null;
      if (words) whenRendered(slot, function () { try { return selectOption(slot, words); } catch (e) { return true; } });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
